import { Able, MoveableManagerInterface } from "moveable";
import { Renderer } from "react-moveable/types";
import React from "preact/compat";
import Interactable from "../interactable";
import { ABLE_OFFSET } from "../interactable-constants";
import constants from "../../constants";
import favoriteAssetService from "../../service/favoriteAssetService";
import store from "../../store";
import { isElementFavorite } from "../interactable-helpers";
import { html } from "tagged-jsx";

interface FavoriteViewableProps {
  favoriteViewable: boolean;
  interactable: Interactable;
}

const FavoriteViewable = {
  name: "favoriteViewable",
  props: {
    interactable: Interactable
  },

  render(moveable: MoveableManagerInterface<FavoriteViewableProps>, Renderer) {
    const rect = moveable.getRect();
    const pixabayInfo = moveable.props.interactable.getElement().attr('data-pixabay-info');
    const dataId = moveable.props.interactable.getElement().attr('data-id');
    const assetId = moveable.props.interactable.getElement().attr('data-asset-id');
    let id = pixabayInfo ? JSON.parse(pixabayInfo).id : dataId ? dataId : assetId ? assetId : '';

    if (!id) {
      const styleAttr = moveable.props.interactable.getElement().find('.img').attr('style');
      if (styleAttr) {
        // Extract the URL from background property in style - handling HTML entities
        const urlMatch = styleAttr.match(/background:[^;]*url\("(.+?)"\)/);
        if (urlMatch && urlMatch[1]) {
          const url = urlMatch[1];
          // Extract the path starting from the member ID (everything after /public/member/)
          const memberPathMatch = url.match(/\/public\/member\/(.*)/);
          if (memberPathMatch && memberPathMatch[1]) {
            id = memberPathMatch[1];
            console.log('id', id);
          }
        }
      }
    }

    let isFavoriteActive = moveable.props.interactable.isFavorite();

    function toggleFavorite(e: any) {
      e.stopPropagation();
      e.preventDefault();

      isFavoriteActive = !isFavoriteActive;
      moveable.props.interactable.toggleFavorite();
    }

    const svg = isFavoriteActive
      ? html`<svg id="heart-filled-icon" viewBox="0 0 20 18">
        <g clip-path="url(#clip0_224_1640)">
            <path d="M14.5911 0.75C12.5941 0.75 10.8517 1.84552 10 3.45035C9.14834 1.84552 7.40587 0.75 5.40889 0.75C2.56024 0.75 0.25 2.96986 0.25 5.70865C0.25 11.119 10 17.25 10 17.25C10 17.25 19.75 11.119 19.75 5.70865C19.75 2.96986 17.4398 0.75 14.5911 0.75Z"
                  fill="#E42436"/>
        </g>
        <defs>
            <clipPath id="clip0_224_1640">
                <rect width="19.5" height="16.5" fill="white" transform="translate(0.25 0.75)"/>
            </clipPath>
        </defs>
    </svg>`(Renderer.createElement)

      : html`<svg id="heart-outlined-icon" viewBox="0 0 23 22">
        <g clip-path="url(#clip0_224_5078)">
            <path d="M21.5922 5.38738C21.2631 4.62533 20.7885 3.93476 20.1951 3.35434C19.6012 2.77219 18.9011 2.30957 18.1326 1.99162C17.3358 1.66062 16.4812 1.4912 15.6183 1.49318C14.4078 1.49318 13.2268 1.82465 12.2005 2.45077C11.9549 2.60055 11.7217 2.76506 11.5007 2.9443C11.2797 2.76506 11.0465 2.60055 10.8009 2.45077C9.77458 1.82465 8.59355 1.49318 7.38306 1.49318C6.51141 1.49318 5.66677 1.66015 4.86878 1.99162C4.0978 2.31082 3.40293 2.76997 2.80628 3.35434C2.21207 3.93411 1.73741 4.62483 1.40918 5.38738C1.06789 6.18046 0.893555 7.02265 0.893555 7.88939C0.893555 8.70702 1.06052 9.55903 1.39199 10.4258C1.66945 11.1501 2.06722 11.9014 2.57547 12.6601C3.38083 13.8608 4.4882 15.113 5.8632 16.3825C8.14177 18.4867 10.3982 19.9403 10.494 19.9992L11.0759 20.3724C11.3337 20.5369 11.6652 20.5369 11.923 20.3724L12.5049 19.9992C12.6007 19.9378 14.8547 18.4867 17.1357 16.3825C18.5107 15.113 19.6181 13.8608 20.4235 12.6601C20.9317 11.9014 21.3319 11.1501 21.6069 10.4258C21.9384 9.55903 22.1054 8.70702 22.1054 7.88939C22.1078 7.02265 21.9335 6.18046 21.5922 5.38738ZM11.5007 18.4302C11.5007 18.4302 2.75963 12.8296 2.75963 7.88939C2.75963 5.38738 4.82949 3.35925 7.38306 3.35925C9.17793 3.35925 10.7346 4.36104 11.5007 5.82443C12.2668 4.36104 13.8235 3.35925 15.6183 3.35925C18.1719 3.35925 20.2418 5.38738 20.2418 7.88939C20.2418 12.8296 11.5007 18.4302 11.5007 18.4302Z"
                  fill="#E42436"/>
        </g>
        <defs>
            <clipPath id="clip0_224_5078">
                <rect width="22" height="22" fill="white" transform="translate(0.5)"/>
            </clipPath>
        </defs>
    </svg>`(Renderer.createElement);

    const style = {
      position: "absolute",
      left: `${rect.width / 2}px`,
      top: `${ABLE_OFFSET.FAVORITE}px`,
      willChange: "transform",
      transform: "translate(-50%, -50%)",
    };

    return html`<div key=${`favorite-${id}`} 
                    class="moveable-favorite favorite-button hint--bottom" 
                    style=${style} 
                    data-hint=${isFavoriteActive ? 'Unfavorite' : 'Favorite'}
                    data-hint-top
                    onClick=${(e: any) => toggleFavorite(e)}>
        ${svg}
    </div>`(Renderer.createElement);
  },
} as Able;

export default FavoriteViewable;
